import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt, formateDate, _isMobile, openComponentUrl } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mapv2assembly from '@/view/map/hdmconfigv2/map';
import mappopupv2 from '@/components/mapv2/popupv2/index';
import typev2 from '@/components/mapv2/typev2/index';
import pointlistv2 from '@/components/mapv2/listv2/index';
import axios from 'axios';
import { BMapLoader } from '@/utils/bdMap.js';
import cdata from '@/view/map/hdmconfigv2/common.js';
import { normalizeMapCoordinates, parseSeniorset } from '@/view/map/js/common';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import routelist from '@/view/map/hdmconfigv2/routelist';
import eryuanIntro from '@/view/map/customv2/eryuanIntro';
import * as turf from '@turf/turf';
export default {
  name: 'superMapv2',
  components: {
    mapv2assembly,
    mappopupv2,
    typev2,
    pointlistv2,
    routelist,
    eryuanIntro
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: Array,
      default: []
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    routelist: {
      type: Array,
      default: []
    },
    rtypelist: {
      type: Array,
      default: []
    },
    senior: {
      type: Object,
      default: {}
    },
    editorlist: {
      type: Array,
      default: []
    },
    domeditorflag: {
      type: Boolean,
      default: false
    },
    editordata: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isMobileflag: false,
      // 移动端判断
      query: '',
      formUserId: '',
      // 最外层样式
      mainStyle: {
        width: '',
        height: '',
        transform: 'scale(1)',
        transformOrigin: '0 0',
        position: 'relative'
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png',
        bgaudio: ''
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: '',
        visit: '',
        bgaudio: ''
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlistflag: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: [],
      typeform: {
        formId: '260297',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 分类列表查询字段
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'selectbox',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      coordinate: '',
      // 当前点击经纬度
      defaultpointList: [],
      // 点位列表数据
      pointList: [],
      // 点位列表数据
      pointListLoading: false,
      pointRequestVersion: 0,
      activePointRequestVersion: 0,
      mapdefaultculturalList: [],
      // 非遗项目列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c'
      },
      // 非遗项目表单字段
      culturalformV2: {
        formId: 'cultural_heritage_project_v2',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a8c2d1023ccb36763e58ee6db1e590218'
      },
      // 非遗项目表单字段
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: 'cultural_heritage_inheritor',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba'
      },
      // 非遗人表单字段
      mapculturalpicList: [],
      // 项目图片列表数据 culturalpic2024052571429
      culturalpicform: {
        formId: '21416',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '0bef8d07ada7bc791d6ebf0bcc4c8a8a'
      },
      // 项目图片表单字段
      mapculturalvideoList: [],
      // 项目视频列表数据 culturalvideo202405281701
      culturalvideoform: {
        formId: '12479',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'ebc411877446a47bd84c8cb30c90410b'
      },
      // 项目视频表单字段
      maprouteList: [],
      // 路线列表数据
      mapcontainer: '',
      routeform: {
        formId: '1626576',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9',
        orderType: 'asc'
      },
      // 路线查询字段集合
      routePop: false,
      bdmaploaction: {},
      rtypeform: {
        formId: '1626580',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd'
      },
      // 路线分类列表查询字段
      rtypeList: [],
      // 路线分类列表数据
      mapTimer: null,
      routeAllSource: [],
      routeAllLen: 0,
      routePoint: [],
      // 路线上所有点
      speeds: [],
      cType: '',
      routejson: {},
      visitform: {
        formId: 'map_visits',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '146f7409beffcce7387a55a86b9f3908f7823c3fe5626184c9149f3cb3a5eefe'
      },
      // 浏览量查询字段
      visitItem: [{
        num: 0
      }],
      mapsenior: {},
      bgaudio: '',
      bgaudioflag: true,
      editorList: [],
      loading: false,
      culturalparams: {
        deptId: '',
        formId: 'cultural_heritage_project'
      },
      pointlistClickFlag: false,
      // 标准地图 列表点击标志
      pointlistClickitem: {},
      // 标准地图 记录列表点击数据
      Difference: '',
      activetype: {},
      // 机器人搜索分类数据
      robotSearchkeyword: '',
      // 机器人搜索关键词
      isRobot: false,
      // 机器人搜索关键词存在标志
      robot: '',
      // 机器人实例
      hljRegionCurrent: '',
      hljRegionPanelVisible: false,
      hljRegionRequestVersion: 0,
      sdauCampusCurrent: '',
      sdauCampusImg: {
        default: 'https://p.cldisk.com/star4/de90fb8fe3e4a4ce7e3384da8e88c351/origin.png',
        active: 'https://p.cldisk.com/star4/1e267103c22443bdee7aeeedc93e29d7/origin.png'
      }
    };
  },
  computed: {
    ...mapGetters(['mapv2info']),
    isHljRegionMap() {
      const fid = this.query && this.query.fid ? this.query.fid : this.$route.query.fid;
      return this.id === 1 && String(fid) === '219963';
    },
    isSdauCampusMap() {
      const fid = this.query && this.query.fid ? this.query.fid : this.$route.query.fid;
      return this.id === 1 && String(fid) === '20218';
    },
    isRegionSwitchMap() {
      return this.isHljRegionMap || this.isSdauCampusMap;
    },
    hljRegionList() {
      return cdata.hljRegionList || [];
    },
    sdauCampusList() {
      return cdata.sdauCampusList || [];
    }
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        if (val) {
          // console.log(`supermapstyle`, val);
          this.mapstyle = val;
          this.styleHandle(val);
        }
      },
      deep: true
    },
    'style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    'style.typeall': {
      handler(val) {
        // console.log(`style.typeall`, val)
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    'style.typeallname': {
      handler(val) {
        // console.log(`style.typeallname`, val)
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        console.log(`superMap-maplayer`, val);
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        console.log(`mappointList`, val);
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    isMobile(val) {
      this.isMobileflag = val;
      this.changeMobile(val);
    },
    routelist: {
      handler(val) {
        this.maprouteList = val;
      },
      deep: true
    },
    rtypelist: {
      handler(val) {
        this.rtypeList = val;
      },
      deep: true
    },
    senior: {
      handler(val) {
        if (val) {
          console.log(`supermapsenior`, val);
          this.mapsenior = val;
        }
      },
      deep: true
    },
    editorlist: {
      handler(val) {
        this.editorList = Array.isArray(val) ? val : [];
      },
      deep: true
    },
    'mapv2info.style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'mapv2info.style': {
      handler(val) {
        // console.log(`this.mapv2info.style`, this.mapv2info.style)
        if (val) this.styleHandle(val);
      },
      deep: true
    },
    'mapv2info.style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    'mapv2info.style.typeall': {
      handler(val) {
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    'mapv2info.style.typeallname': {
      handler(val) {
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    'mapv2info.style.routebutton': {
      handler(val) {
        this.mapstyle.routebutton = val;
      },
      deep: true
    },
    'mapv2info.style.routebuttontext': {
      handler(val) {
        this.mapstyle.routebuttontext = val;
      },
      deep: true
    },
    'mapv2info.style.routepos': {
      handler(val) {
        this.mapstyle.routepos = val;
      },
      deep: true
    },
    'mapv2info.style.routebtn': {
      handler(val) {
        this.mapstyle.routebtn = val;
      },
      deep: true
    },
    'mapv2info.style.allroutepreview': {
      handler(val) {
        this.mapstyle.allroutepreview = val;
      },
      deep: true
    },
    'mapv2info.style.listStyleIndex': {
      handler(val) {
        // console.log(`mapv2info.style.listStyleIndex`, val);
        if (val) this.mapstyle.listStyleIndex = val;
      },
      deep: true
    },
    'mapv2info.senior.visit': {
      handler(val) {
        // console.log(`mapv2info.senior.visit`, val);
        this.mapsenior.visit = val;
      },
      deep: true
    },
    'mapv2info.senior.visitname': {
      handler(val) {
        // console.log(`mapv2info.senior.visitname`, val);
        this.mapsenior.visitname = val;
      },
      deep: true
    },
    'mapv2info.senior.effect': {
      handler(val) {
        // console.log(`mapv2info.senior.effect`, val);
        this.mapsenior.effect = val;
        if (val) this.effectAnimate(val);
      },
      deep: true
    }
  },
  created() {
    this.mapconStyle();
    this.query = this.$route.query;
    // 洱源 / 晋江：在子组件挂载前就打开 loading，避免简介弹窗抢先弹出
    if ((this.query.fid === '291435' || this.query.fid === '2226') && this.id === 1) this.loading = true;
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    if (this.isHljRegionMap) this.syncHljRegionCurrent(this.formUserId);
    if (this.isSdauCampusMap) this.syncSdauCampusCurrent(this.formUserId);
    // 洱源 晋江先定制添加loading加载页
    if ((this.query.fid === '291435' || this.query.fid === '2226') && this.id === 1) this.loading = true;
    if (this.query.fid === '130056') this.mapelem.golist = 'https://p.ananas.chaoxing.com/star3/origin/637b12c7f72ac381bb0d8e8281360033.png';
    let customArr = cdata.customMap;
    // 滨州地图等跳转 先定制 后面在做通用化
    if (this.id === 1) {
      let gotoItem = customArr.find(elem => {
        if (String(elem.fid) !== String(this.query.fid)) return false;
        // 配置了 formUserId：必须与 URL 一致（同 fid 多页，如川工上下篇）
        if (elem.formUserId !== undefined && elem.formUserId !== '') {
          return String(elem.formUserId) === String(this.query.formUserId);
        }
        // 未配置 formUserId：仅按 fid
        return true;
      });
      if (gotoItem !== undefined && gotoItem.open !== undefined && gotoItem.open === true) {
        // 定制地图 跳转到另一个地图链接
        let cparams = [];
        Object.keys(this.query).forEach(elem => {
          cparams.push(`${elem}=${this.query[elem]}`);
        });
        window.location.href = location.protocol + '//' + location.host + '/micro-frontend/customMap/#/' + gotoItem.page + '?' + cparams.join('&');
        return;
      }
      if (this.query.fid === '2896' && this.query.formUserId === '5043443130') {
        this.transformPage(gotoItem);
        return;
      }
      if (gotoItem !== undefined && gotoItem.screen === undefined || gotoItem !== undefined && gotoItem.screen !== undefined && gotoItem.screen !== '' && _isMobile()) {
        if (!(this.query.fid === '138061' && this.query.formUserId !== '1211818131')) {
          this.transformPage(gotoItem);
        }
      }
    }
    console.log(`this.id`, this.id);
    // 展示页请求相关接口数据
    if (this.id === 1) {
      this.setComonStyle();
      this.getMapData();
    }
    this.$nextTick(() => {
      this.loadBmap();
      this.getCxRobotSdkJs();
    });
  },
  methods: {
    syncHljRegionCurrent(formUserId) {
      const regionName = cdata.hljRegionFormUserIdReverse[String(formUserId)];
      this.hljRegionCurrent = regionName || (this.hljRegionList[0] ? this.hljRegionList[0].name : '');
    },
    syncSdauCampusCurrent(formUserId) {
      const campusName = cdata.sdauCampusFormUserIdReverse[String(formUserId)];
      this.sdauCampusCurrent = campusName || (this.sdauCampusList[0] ? this.sdauCampusList[0].name : '');
    },
    toggleHljRegionPanel() {
      this.hljRegionPanelVisible = !this.hljRegionPanelVisible;
    },
    isCurrentHljRegionRequest(requestVersion) {
      return !this.isRegionSwitchMap || requestVersion === null || requestVersion === this.hljRegionRequestVersion;
    },
    selectHljRegion(region) {
      if (!region || !region.formUserId) return;
      if (String(region.formUserId) === String(this.formUserId) && this.loadingmap) {
        this.hljRegionPanelVisible = false;
        return;
      }
      this.hljRegionCurrent = region.name;
      this.hljRegionPanelVisible = false;
      this.switchHljRegion(region.formUserId);
    },
    selectSdauCampus(campus) {
      if (!campus || !campus.formUserId) return;
      if (String(campus.formUserId) === String(this.formUserId) && this.loadingmap) return;
      this.sdauCampusCurrent = campus.name;
      this.switchSdauCampus(campus.formUserId);
    },
    switchSdauCampus(formUserId) {
      this.resetHljRegionMapState();
      this.formUserId = String(formUserId);
      this.query = Object.assign({}, this.query, {
        formUserId: String(formUserId)
      });
      this.hljRegionRequestVersion += 1;
      this.getMapData(formUserId, this.hljRegionRequestVersion);
    },
    resetPointSearchStr() {
      this.searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'selectbox',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      };
    },
    resetHljRegionMapState() {
      this.loadingmap = false;
      this.popshowflag = false;
      this.routePop = false;
      this.cType = '';
      this.activetype = {};
      this.pointlistClickFlag = false;
      this.pointlistClickitem = {};
      this.pointform.page = 1;
      this.defaultpointList = [];
      this.pointList = [];
      this.typeList = [];
      this.maprouteList = [];
      this.rtypeList = [];
      this.routeform.page = 1;
      this.rtypeform.page = 1;
      this.pointRequestVersion += 1;
      this.activePointRequestVersion = this.pointRequestVersion;
      this.pointListLoading = false;
      this.mapdefaultculturalList = [];
      this.mapculturalList = [];
      this.mapstreetcode = [];
      this.mapLayers = {};
      this.form = {};
      this.formatData = {};
      this.resetPointSearchStr();
      if (this.$refs.routelist && this.$refs.routelist.routebtnHide) this.$refs.routelist.routebtnHide();
      if (this.$refs.mapv2assembly && this.$refs.mapv2assembly.removeRoutesource) this.$refs.mapv2assembly.removeRoutesource();
    },
    switchHljRegion(formUserId) {
      this.resetHljRegionMapState();
      this.formUserId = String(formUserId);
      this.query = Object.assign({}, this.query, {
        formUserId: String(formUserId)
      });
      this.hljRegionRequestVersion += 1;
      this.getMapData(formUserId, this.hljRegionRequestVersion);
    },
    transformPage(gotoItem) {
      let cparams = [];
      Object.keys(this.query).forEach(elem => {
        cparams.push(`${elem}=${this.query[elem]}`);
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=' + gotoItem.page + '?' + cparams.join('&');
    },
    ...mapMutations(['SET_MAPSENIOR', 'SET_MAPVIEW', 'SET_MAPFORM', 'SET_MAPFORMITEM', 'SET_MAPSTYLEITEM', 'SET_MAPDRAWLAYER', 'SET_COORDINATE', 'SET_MAPROUTESOURCE']),
    loadBmap() {
      BMapLoader().then(BMap => {
        this.mapTimer = setInterval(() => {
          if (window.BMapGL && window.BMapGL.Map && window.BMapGL.Point) {
            this.mapcontainer = new BMap.Map('bdmap');
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(a => {
              console.log(a);
              this.bdmaploaction.address = a.address;
              this.bdmaploaction.lng = a.point.lng;
              this.bdmaploaction.lat = a.point.lat;
              localStorage.setItem('bdlocation', JSON.stringify(this.bdmaploaction));
            });
            clearInterval(this.mapTimer);
            this.mapTimer = null;
          }
        }, 100);
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (_isMobile()) this.isMobileflag = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
    * 定位点格式化
    */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    styleHandle(val) {
      // console.log(`styleHandle`, val)
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat(val[`${key}pos`] !== undefined ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
      });
      if (val.typedisplay) this.modulestyle.type = Object.assign({}, this.modulestyle.type, val.typedisplay);
      if (val.visitdom !== undefined) this.modulestyle.visit = Object.assign({}, this.modulestyle.visit, val.visitdom[0]);
      // console.log(`this.modulestyle`, this.modulestyle)
    },
    mapformHandle(val) {
      console.log(`mapformHandle`, val);
      if (!this.isMobileflag) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : '';
      }
      if (this.isMobileflag) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : '';
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : '';
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : '';
      if (val.bgaudioicon && val.bgaudioicon[0]) this.mapelem.bgaudio = getImg(val.bgaudioicon[0]);
      this.showtype = val.showtype;
      this.showlistflag = val.showlistflag;
      if (val.customvisits !== undefined && val.visits !== undefined) this.visitItem[0].num = Number(val.customvisits) + Number(val.visits);
      /* centerflag 配置页调整地图center时 不触发不请求接口 */
      if (!val.centerflag) this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
      /* 若包含背景音乐 */
      if (val.bgaudiofile && val.bgaudiofile[0]) this.getBgaudiofile(val.bgaudiofile[0]);
      if (val.editorList && val.editorList.length > 0) this.editorList = val.editorList;
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = '375px';
        this.mainStyle.height = '667px';
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    markermoveend(val) {
      console.log(`val`, val);
      if (this.id === 1) {
        // 点击单个路线时 禁止缩放更新数据
        if (this.routePoint.length > 0) return;
        // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
        if (this.form.cTemplateScore === 1) {
          this.culturalform.page = 1;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
          return;
        }
        this.popshowflag = false;
        // this.removeAlliconsource()
        let zoom = val;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          if (this.Difference !== '') this.Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`this.Difference`, this.Difference);
          zoom += this.Difference;
        }
        let orData = [];
        console.log(`minZoom`, minZoom);
        console.log(`zoom`, zoom);
        if (this.pointlistClickFlag) zoom = this.mapview.maxZoom;
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        // this.pointList = []
        this.getpointData();
      } else {
        this.$emit('markermoveend', val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
    * 定位点击操作
    * @param {Object} feature 选中数据
    */
    markerclick(feature) {
      this.pointdetail = {};
      this.popshowflag = false;
      console.log(`this.pointList`, this.pointList);
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2;
      if (feature === undefined) return;
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 5;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === 'Point') {
        let id = feature.get('id');
        let score = feature.get('score');
        let currentInfo = '';
        if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
          return item.id === id;
        });
        if (this.mapculturalList.length > 0) currentInfo = this.mapculturalList.find(item => {
          return item.id === id;
        });
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
        // 非遗模版获取弹窗
        if (score === 1) this.culturalDetail(currentInfo, feature);
      }
      // 总地图点击进入分地图
      if (gtype === 'Polygon' && this.form.ishaschild === '是' && this.id === 1) {
        let code = feature.get('code');
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: '177623',
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': '50',
                'compt': 'editinput',
                'express': 'like',
                'val': code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split('?')[1];
            let cparams = cquery.split('&');
            cparams = cparams.map(item => {
              let itemarr = item.split('=');
              if (itemarr[0] === 'formUserId') {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join('=');
              }
              return item;
            });
            window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
          }
        });
      }
      // LineString路线点击显示详情
      if (gtype === 'LineString' && feature.get('type') === 'allroute') {
        let id = feature.get('id');
        let routeItem = this.maprouteList.find(item => {
          return item.id === id;
        });
        if (routeItem !== undefined) {
          this.routePop = true;
          this.routeDetail = routeItem;
        }
      }
      if (gtype === 'Point' && feature.get('type') === 'location') {
        ElMessage({
          message: '【仅用户在地图所选区域内生效】',
          type: 'warning'
        });
      }
    },
    /**
    * 标准模版获取点位详情
    * @param {Object} feature 选中数据
    */
    standardDetail(currentInfo) {
      let formatinfo = {};
      const itemformData = _.cloneDeep(currentInfo.itemformdata);
      Object.keys(itemformData).forEach(key => {
        formatinfo[key] = itemformData[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';

      // 兼容视频子表单字段 20250822 77名称 76注释 79视频
      if (formatinfo.vedionew !== undefined) {
        formatinfo.video = formatinfo[79].length > 0 ? formatinfo[79].map((item, index) => {
          item.title = formatinfo[79].length === 1 ? formatinfo[77] : formatinfo[77][index];
          item.desc = formatinfo[79].length === 1 ? formatinfo[76] : formatinfo[76][index];
          if (item.title === '') item.title = item.name.replace(`.${item.suffix}`, '');
          this.$api.getUrlByObjectId(item.objectId).then(res => {
            item.url = res.http;
          });
          return item;
        }) : '';
      }
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, '');
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : '';
      console.log(`formatinfo.video`, formatinfo.video);
      if (formatinfo['42'] === '弹窗') {
        console.log(`this.popmodeltype`, this.popmodeltype);
        if (this.query.poprelationForm !== undefined && this.query.poprelationForm !== '') {
          // url存在poprelationForm字段 则显示定制化弹窗
          // true/5→comp6, 6→comp7, 7→comp8(中国民航大学)
          this.popmodeltype = this.query.poprelationForm === 'true' ? 5 : Number(this.query.poprelationForm);
        }
        this.pointdetail = formatinfo;
        this.popshowflag = true;
      }
      if (formatinfo['42'] === '链接' && formatinfo['44'] !== '') {
        let url = formatinfo['44'];
        if (formatinfo['44'].includes('superMapv2')) {
          let cparams = formatinfo['44'].split('?')[1];
          url = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams;
        }
        window.open(url);
      }

      // 标准模版 列表点击后 再点击画布上的点 重置点位zIndex
      if (this.pointlistClickitem !== undefined) {
        this.$refs.mapv2assembly.resetPointzIndex({
          id: ''
        });
      }
    },
    /**
    * 非遗模版获取点位详情
    * @param {Object} feature 选中数据
    */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get('xy');
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.id = currentInfo.id;
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== '' ? `${formatinfo.detailUrl}${formatinfo.detailUrl.includes('?') ? '&' : '?'}mapid=${formatinfo.number}` : '';
      formatinfo.pixelcoordinate = this.$refs.mapv2assembly.getmapPixelFromCoordinate(currentInfo);
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.getCulturalperson(formatinfo);
      this.getCulturalpic(formatinfo);
      this.getCulturalvideo(formatinfo);
      // 客家(闽西)非遗博物馆 龙岩
      if (this.query.fid === '138053') {
        this.getSeminar(formatinfo);
        this.popmodeltype = 4; //先定制后删除
      }
      if (this.popmodeltype === 1 && !this.isMobileflag) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
    * 点位获取对应非遗传承人数据
    * @param {Object} feature 选中数据
    */
    getCulturalperson(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'project_name',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.title
          }]
        }]
      };
      this.culturalpersonform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpersonform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpersonform.page === 1) that.mapculturalpersonList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpersonList = that.culturalpersonform.page === 1 ? res.dataList : that.mapculturalpersonList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpersonform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.person = that.mapculturalpersonList;
        }
      });
    },
    /**
    * 点位获取对应项目图片表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalpic(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': this.query.fid === '138053' ? 'number' : '19',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.number
          }]
        }]
      };
      // 龙岩138053
      if (this.query.fid === '138053') {
        this.culturalpicform.formId = '1539909';
        this.culturalpicform.t = '28cfc16722e657e0a8544fcc4170635a1838e364615b9ea94f1161c5b1664675';
      }
      this.culturalpicform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpicform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpicform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpicform.page === 1) that.mapculturalpicList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpicList = that.culturalpicform.page === 1 ? res.dataList : that.mapculturalpicList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpicform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.pictureList = that.mapculturalpicList;
        }
      });
    },
    /**
    * 点位获取对应项目视频表单数据
    * @param {Object} feature 选中数据
    */
    getCulturalvideo(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': this.query.fid === '138053' ? 'number' : '1',
            'compt': this.query.fid === '138053' ? 'editinput' : 'selectbox',
            'express': '===',
            'val': this.query.fid === '138053' ? formatinfo.number : [formatinfo.title]
          }]
        }]
      };
      if (this.query.fid === '138053') {
        this.culturalvideoform.formId = '1540105';
        this.culturalvideoform.t = 'af229fb2c9b88028bfb98461282282f20b24954a46827574c4a07d6218162bb6';
      }
      this.culturalvideoform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalvideoform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalvideoform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalvideoform.page === 1) that.mapculturalvideoList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalvideoList = that.culturalvideoform.page === 1 ? res.dataList : that.mapculturalvideoList.concat(res.dataList);
          // if (res.totalPage > 1) that.culturalvideoform.page++
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.videoList = that.mapculturalvideoList;
        }
      });
    },
    /**
    * 点位获取对应传习所表 【龙岩地图定制】 202406251652 看后期如何定制 url：seminar202406251701
    * @param {Object} feature 选中数据
    */
    getSeminar(formatinfo) {
      let seminar = {
        formId: '1575388',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '4f4bf90d9e5aaf56878c6788d5471a5acb372f5a11d78917d362ce3fb72373ed'
      };
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '3',
            'compt': 'editinput',
            'express': '===',
            'val': formatinfo.number
          }]
        }]
      };
      seminar.searchStr = encodeURI(JSON.stringify(searchStr));
      seminar.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(seminar).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.pointdetail.seminarList = res.dataList;
        }
      });
    },
    /**
    * 弹窗关闭事件
    */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
      if (!this.isMobileflag) document.querySelector('.map_content').style.zIndex = 2;
    },
    /**
    * 分类选择事件
    */
    typeselect(val) {
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit('typeselect', val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    removeRoutesource() {
      this.$refs.mapv2assembly.removeRoutesource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          let golistWhitelist = ['201028', '130056'];
          this.showgolist = golistWhitelist.includes(this.query.fid) && val.ishaschild !== '是';
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      this.culturalparams.deptId = this.query.fid;
      this.$api.formStruct(this.culturalparams).then(res => {
        if (res === '表单不存在') {
          this.culturalparams.formId = this.culturalformV2.formId;
          this.getCulturalFormStruct();
          return;
        }
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
        this.getHeritageLevel();
      });
    },
    /**
     * 获取非遗级别数据
     */
    getHeritageLevel() {
      let that = this;
      const levelform = {
        formId: 'cultural_heritage_level',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c6214264990ae6ee87a7ea8354f1ddd10d27fc0b22c007dd5f32f533e2812ebe6a5db5'
      };
      levelform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(levelform).then(res => {
        if (res.totalRow > 0) {
          let dataList = that.formdataformat(res);
          that.cformoption.level = dataList.map(item => {
            return {
              title: item.itemformdata.title,
              order: item.itemformdata.order
            };
          });
        }
      });
    },
    setComonStyle() {
      document.querySelector('html').style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData(formUserId = this.query.formUserId, hljRequestVersion = null) {
      let that = this;
      const currentFormUserId = String(formUserId);
      if (this.isRegionSwitchMap) {
        if (hljRequestVersion === null) {
          this.hljRegionRequestVersion += 1;
          hljRequestVersion = this.hljRegionRequestVersion;
        }
        this.formUserId = currentFormUserId;
        this.query = Object.assign({}, this.query, {
          formUserId: currentFormUserId
        });
        if (this.isHljRegionMap) this.syncHljRegionCurrent(currentFormUserId);
        if (this.isSdauCampusMap) this.syncSdauCampusCurrent(currentFormUserId);
      }
      this.$api.singleformUserId(this.query.fid, '177623', currentFormUserId).then(res => {
        if (!that.isCurrentHljRegionRequest(hljRequestVersion)) return;
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct(hljRequestVersion);
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct(hljRequestVersion = null) {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        if (!this.isCurrentHljRegionRequest(hljRequestVersion)) return;
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        this.mapview = this.mapv2info.view;
        this.editlogic(this.formatData, hljRequestVersion);
        this.gettypeList(hljRequestVersion);
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data, hljRequestVersion = null) {
      if (!this.isCurrentHljRegionRequest(hljRequestVersion)) return;
      let that = this;
      this.mapLayers.tiles = true;
      this.mapLayers.json = true;
      this.mapLayers.static = false;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
      };
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      console.log(`this.form`, this.form);
      console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlistflag = this.jsonOption.style.showlistflag;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : '全部';
      this.form.routelinetype = this.jsonOption.style.routelinetype ? this.jsonOption.style.routelinetype : 1;
      if (this.form.fillcolor) this.form.fillcolor = [...JSON.parse(this.form.fillcolor.replace(/(<\/?p.*?>)/gi, ''))];
      this.form.fillimageindex = this.form.fillimageindex && this.form.fillimageindex !== '' ? Number(this.form.fillimageindex) : this.form.fillimageindex === '' ? this.form.fillimageindex : 1;
      if (this.form.mapmodetype === '静态地图') {
        if (this.isMobileflag) {
          this.mapLayers.staticimage = this.form.app_static_img && this.form.app_static_img.length > 0 ? getImg(this.form.app_static_img[0]) : getImg(this.form.static_img[0]);
        } else {
          if (this.form.static_img && this.form.static_img.length > 0) this.mapLayers.staticimage = getImg(this.form.static_img[0]);
        }
      }
      if (this.form.mapmodetype === this.formoption.mapmodetype[1].title && this.form.filltype === this.formoption.filltype[1].title && this.form.fillclipimage !== '') {
        this.form.fillclipimage = this.form.fillclipimage.replace(/(<\/?p.*?>)/gi, '').match(/src="([^"]*)"/i)[1];
        this.mapLayers.staticimage = this.form.fillclipimage;
      }
      if (this.form.background_img && this.form.background_img.length > 0) this.mapLayers.tiles = false;
      if (this.mapLayers.staticimage !== '') this.mapLayers.static = true;
      if (this.form.viewShadow !== undefined && this.form.viewShadow.length > 0) {
        if (Array.isArray(this.form.viewShadow) && this.form.viewShadow[0].val === '显示') {
          const shadowFlag = this.form.viewShadow[0].val === '显示' ? true : false;
          this.mapLayers.shadow = {
            shadowFlag: shadowFlag,
            data: this.form.mapShadow
          };
        }
      }
      console.log(`this.mapLayers`, this.mapLayers);
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlistflag: this.jsonOption.style.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.mapview = this.jsonOption.view;
      this.mapstyle = this.jsonOption.style;
      this.mapstyle.typeall = this.form.typeall;
      this.mapstyle.typeallname = this.form.typeallname;
      this.mapsenior = this.jsonOption.senior;

      // 若开启浏览量 增加浏览量
      if (this.mapsenior.visit) this.getVisits();

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      if (this.form.componentjson !== undefined) {
        let comptdata = this.form.componentjson.replace(/(<\/?p.*?>)/gi, '');
        if (comptdata !== '') {
          let data = JSON.parse(comptdata);
          this.form.editorList = this.isMobileflag ? data.appList : data.List;
          this.form.pcwidth = data.pcwidth;
          this.form.pcheight = data.pcheight;
        }
      }
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        // console.log(`this.jsonOption.style`, this.jsonOption.style)
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Array]' && this.jsonOption.geojson[0].code) {
        this.mapstreetcode = this.jsonOption.geojson.map(item => {
          return item.code;
        });
      } else if (Object.prototype.toString.call(this.jsonOption.geojson) === '[object Object]' && this.jsonOption.geojson.code) {
        this.mapstreetcode = [this.jsonOption.geojson.code];
      }
      let adcode = this.jsonOption.view.adcode;
      if (this.mapstreetcode.length > 0) {
        axios.get(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (!that.isCurrentHljRegionRequest(hljRequestVersion)) return;
          if (res.status === 200) {
            let jsondata = res.data;
            let filterJson = [];
            that.mapstreetcode.forEach(street => {
              jsondata.features.forEach(feature => {
                if (Number(feature.properties.code) === Number(street)) filterJson.push(feature);
              });
            });
            jsondata.features = filterJson;
            if (that.mapview.center === undefined || this.mapview.center[0] === null) {
              const bbox = turf.bbox(jsondata);
              that.mapview.center = jsondata.features[0].properties.centroid;
              that.mapview.extent = bbox;
              that.form.transform_extent = bbox.join(',');
            }
            that.mapLayers.geojson = jsondata;
            that.loadingmap = true;
          }
        }).catch(error => {});
        return;
      }
      // 自定义json数据
      if (this.jsonOption.view.adcode === 'region') {
        let datacoord = this.jsonOption.geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, 'EPSG:4326', 'EPSG:3857'));
        });
        this.jsonOption.geojson.features[0].geometry.coordinates[0] = changedata;
        this.mapLayers.geojson = {
          type: 'FeatureCollection',
          features: this.jsonOption.geojson.features
        };
      }
      if (!this.isCurrentHljRegionRequest(hljRequestVersion)) return;
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(',');
      this.form.transform_extent = view.extent.join(',');
    },
    /**
     * 获取分类列表数据
     */
    gettypeList(hljRequestVersion = null) {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '3',
            'compt': 'selectbox',
            'express': '===',
            'val': [this.formatData.title]
          }]
        }]
      };
      this.typeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        if (!that.isCurrentHljRegionRequest(hljRequestVersion)) return;
        // console.log(res);
        if (res.totalRow > 0) {
          this.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          if (!this.mapstyle.typeall) {
            this.searchStr.filters.push({
              "model": 0,
              "filters": [{
                'alias': 'map_type2',
                'compt': 'editinput',
                'express': this.query.fid !== '2226' ? 'like' : '===',
                'val': this.typeList[0].itemformdata.title
              }]
            });
          }
          console.log(`typeList`, this.typeList);
          // 2226 意图游晋江
        }

        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        this.searchStr.filters[0].filters[0].val = [`${this.formatData.title}`];
        let zoom = this.mapview.zoom;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`Difference`, Difference);
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.getpointData();

        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          let searchStr = {
            model: 0,
            filters: [{
              "model": 0,
              "filters": [{
                'alias': 'correlation_map',
                'compt': 'selectbox',
                'express': '===',
                'val': ['是']
              }, {
                'alias': 'correlation_show',
                'compt': 'selectbox',
                'express': '!==',
                'val': ['隐藏']
              }]
            }]
          };
          this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
          this.culturalform.deptId = this.query.fid;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
        }
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(val, requestVersion = null) {
      let that = this;
      if (requestVersion === null) {
        this.pointRequestVersion += 1;
        requestVersion = this.pointRequestVersion;
        this.activePointRequestVersion = requestVersion;
        this.pointListLoading = true;
      }
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        if (requestVersion !== that.activePointRequestVersion) return;
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.defaultpointList = [];
          let dataList = that.formdataformat(res, 'point');
          that.defaultpointList = that.pointform.page === 1 ? dataList : that.defaultpointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage > 1 && res.totalPage + 1 === that.pointform.page) {
            that.loading = false;
            that.pointList = that.defaultpointList;
            that.pointListLoading = false;
            // 添加标准模版 列表点击数据 事件判断
            if (that.pointlistClickFlag && that.pointlistClickitem !== undefined) {
              var coordinates = that.pointlistClickitem.itemformdata.map_coordinates.split(',').map(Number);
              that.pointList = that.defaultpointList.map(point => {
                point.itemformdata.zIndex = point.id === that.pointlistClickitem.id ? 99 : 1;
                return point;
              });
              that.mapview.center = coordinates;
              that.pointlistClickFlag = false;
            }
            // 若机器人模式 则显示弹窗
            if (that.isRobot) {
              const robotSearchItem = that.pointList.find(point => point.itemformdata.place_name === that.robotSearchkeyword);
              that.standardDetail(robotSearchItem);
              console.log(`that.robot`, that.robot);
              that.robot.closeWin();
            }
          }
          if ((res.totalPage === 1 || res.totalPage === that.pointform.page) && val === undefined) that.getroutetypeData();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData(val, requestVersion);
        } else {
          if (that.pointform.page === 1) {
            that.defaultpointList = [];
            that.pointList = [];
            if (val === undefined) that.getroutetypeData();
          }
          that.pointListLoading = false;
        }
      }).catch(() => {
        if (requestVersion !== that.activePointRequestVersion) return;
        that.pointListLoading = false;
      });
    },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data, pointZoom) {
      this.cType = data;
      this.popshowflag = false;
      this.pointlistClickFlag = false;
      this.removeAlliconsource();
      let dindex = data.index;
      let val = dindex === 0 ? '' : !data.child ? data.item.itemformdata : data.child;
      let typesearchflag = false;
      if (dindex === 0) {
        this.searchStr.filters.forEach((item, index) => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') this.searchStr.filters.splice(index, 1);
        });
      } else {
        this.searchStr.filters.forEach(item => {
          if (item.filters.length > 0 && item.filters[0].alias === 'map_type2') {
            item.filters[0].val = val.title;
            typesearchflag = true;
          }
        });
        if (!typesearchflag) {
          this.searchStr.filters.push({
            "model": 0,
            "filters": [{
              'alias': 'map_type2',
              'compt': 'editinput',
              'express': this.query.fid !== '2226' ? 'like' : '===',
              'val': val.title
            }]
          });
        }
      }
      let zoom = this.mapview.zoom;
      let minZoom = this.mapview.minZoom;
      // 如果有pointZoom 则使用pointZoom robot使用
      if (pointZoom !== undefined) zoom = pointZoom;
      if (this.isMobileflag) {
        if (this.Difference !== '') this.Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
        console.log(`this.Difference`, this.Difference);
        zoom += this.Difference;
      }
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          'alias': 'map_level',
          'compt': 'editinput',
          'express': '===',
          'val': i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0 && item.filters[0].alias === '40' && item.filters[0].val === '') item.filters[0].val = [`${this.form.title}`];
        if (item.model === 1) item.filters = orData;
      });
      if (this.pointform.deptId === undefined) this.pointform.deptId = this.query.fid;
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      this.getpointData();
      console.log(`点击非全部类型 隐藏路线列表`);
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        if (res === '表单不存在') {
          this.culturalform.formId = this.culturalformV2.formId;
          this.culturalform.t = this.culturalformV2.t;
          this.getIntangibleCulturalHeritageData();
          return;
        }
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) that.mapdefaultculturalList = [];
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          if (res.totalPage > 1 && that.culturalform.page === res.totalPage + 1 || res.totalPage === 1) {
            if (that.query.fid === '138053') {
              // 龙岩非遗 过滤【表单审核状态通过】数据
              that.mapculturalList = that.mapdefaultculturalList.filter(item => {
                return item.aprvStatus === 1;
              });
            } else {
              that.mapculturalList = that.mapdefaultculturalList;
            }
          }
          if (res.totalPage > 1 && res.totalPage >= that.culturalform.page) that.getIntangibleCulturalHeritageData();
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = getImg(type.itemformdata.icon[0]);
        }
        if (itemformat.correlation_picture !== undefined) {
          const picture = itemformat.correlation_picture;
          if (picture.length > 0 && picture[0].fileUrl) itemformat.icon = getImg(picture[0]);
        }
        item.itemformdata = itemformat;
      });
      this.mapdefaultculturalList = this.culturalform.page === 1 ? res.dataList : this.mapdefaultculturalList.concat(res.dataList);
    },
    pointlistClick(item) {
      let components = this.$refs.pointlist.$options.components;
      Object.keys(components).forEach(key => {
        if (this.mapstyle.listStyleIndex === Number(key.charAt(key.length - 1))) components[key].methods.listDown();
      });
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (this.cTemplateScore === 0) {
        const pointlistClickitem = this.pointList.find(elem => elem.id === item.id);
        console.log(`pointlistClickitem`, pointlistClickitem);
        if (pointlistClickitem !== undefined) {
          var coordinates = pointlistClickitem.itemformdata.map_coordinates.split(',').map(Number);
          this.mapview.center = coordinates;
          this.$refs.mapv2assembly.resetPointzIndex(pointlistClickitem);
          return;
        }
        this.pointlistClickFlag = true;
        this.pointlistClickitem = item;
        this.searchStr = this.removeFilterByAlias(this.searchStr, 'map_type2');
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.mapview.zoom = this.mapview.maxZoom;
        if (this.mapview.zoom === this.mapview.maxZoom) this.getpointData();
        // this.standardDetail(item)
      }
      if (this.cTemplateScore === 1 && citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    },
    removeFilterByAlias(search, targetAlias) {
      if (!search || !search.filters) return search;

      // 遍历 filters 数组
      for (let i = 0; i < search.filters.length; i++) {
        const filter = search.filters[i];

        // 检查当前层级的 filters
        if (filter.filters && Array.isArray(filter.filters)) {
          // 递归处理嵌套的 filters
          this.removeFilterByAlias(filter, targetAlias);

          // 如果嵌套的 filters 被清空了，可以考虑删除这个父级
          if (filter.filters.length === 0) {
            search.filters.splice(i, 1);
            i--;
          }
        }

        // 检查当前层级的 filter 对象本身
        if (filter.alias === targetAlias) {
          search.filters.splice(i, 1);
          i--; // 调整索引
        }
      }
      return search;
    },
    listUp() {
      this.pointdetail = {};
      this.popshowflag = false;
    },
    formdataformat(res, type) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        if (type !== undefined && type === 'point') {
          // 判断点位样式字段是否存在 并赋值
          if (itemformat.seniorset !== undefined && itemformat.seniorset !== '') {
            itemformat.seniorset = parseSeniorset(itemformat.seniorset);
          }
          if (itemformat.map_coordinates !== undefined && itemformat.map_coordinates !== '') {
            itemformat.map_coordinates = normalizeMapCoordinates(itemformat.map_coordinates);
          }
        }
        return item;
      });
    },
    getroutetypeData() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          let sortdataList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.rtypeList = that.routeform.page === 1 ? sortdataList : that.rtypeList.concat(sortdataList);
          if (res.totalPage > 1) that.rtypeform.page++;
          if (res.totalPage === 1 || res.totalPage === that.rtypeform.page) that.getrouteData();
          if (res.totalPage > 1 && res.totalPage >= that.rtypeform.page) that.getroutetypeData();
        }
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'mapbelongId',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }]
        }]
      };
      this.routeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.routeform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.maprouteList = [];
          let dataList = that.formdataformat(res);
          that.maprouteList = that.routeform.page === 1 ? dataList : that.maprouteList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          // if (res.totalPage === 1 || res.totalPage === that.routeform.page) {
          //     if (that.cType === '') that.routeHandle(that.maprouteList)
          // }
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    /**
     * 获取下地图所有点位数据
     * @date 2025-05-20
     */
    async resetPointData(val) {
      let resetStr = _.cloneDeep(this.searchStr);
      if (this.id === 0) {
        this.pointform.deptId = this.$route.query.fid;
        resetStr.filters[0].filters[0].val = [`${this.form.title}`];
      }
      resetStr.filters = resetStr.filters.filter(item => item.filters[0].alias === '40');
      this.pointform.searchStr = encodeURI(JSON.stringify(resetStr));
      let that = this;
      await this.$api.singleadvanceSearch(this.pointform).then(res => {
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.defaultpointList = [];
          let dataList = that.formdataformat(res, 'point');
          that.defaultpointList = that.pointform.page === 1 ? dataList : that.defaultpointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage > 1 && res.totalPage + 1 === that.pointform.page) {
            that.pointList = that.defaultpointList;
            const onetimer = setTimeout(() => {
              // 泸西 默认选择第一条路线
              if (that.query.fid === '131792') {
                that.$refs.routelist.routeClick(that.maprouteList[0]);
                clearTimeout(onetimer);
              }
            }, 1000);
            if (that.query.fid === '131792') return;
            if (val) that.routeClick(that.maprouteList);
          }
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getpointData();
        }
      });
    },
    /**
     * 默认显示所有线路
     * @date 2025-05-20
     */
    previewAllroute(val) {
      this.resetPointData(val);
    },
    routeChange(val) {
      console.log(`routeChange`, val);
      if (val.length === 0) {
        this.typeClick(this.cType === '' ? {
          index: 0,
          item: ''
        } : this.cType);
        return;
      }
      this.routeshow(true);
      this.getRouteInfo(val);
    },
    getRouteInfo(val) {
      // 记录多条数据中的所有点
      let routeAllPoint = [];
      // 记录多条线路的点
      let routesLinePoints = [];
      this.speeds = [];
      val.forEach(item => {
        const routejson = {
          ...JSON.parse(item.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ''))
        };
        item.itemformdata.routejson = routejson;
        const routedata = routejson.routedata;
        const routesPoint = [];
        for (let i = 0; i <= routedata.length - 1; i++) {
          const item = routedata[i];
          let route = this.pointList.find(point => {
            return point.id === item.id;
          });
          routesPoint.push(route);
          if (route !== undefined && !routeAllPoint.some(child => child.id === item.id)) routeAllPoint.push(route);
          if (val.length === 1 && item.speed !== undefined) this.speeds.push(item.speed);
        }
        routesLinePoints.push(routesPoint);
      });
      let routesLatLon = [];
      routesLinePoints.forEach((item, index) => {
        let routes = [];
        for (let i = 0; i < item.length - 1; i++) {
          let start = item[i].itemformdata.map_coordinates.split(',').map(parseFloat);
          let end = item[i + 1].itemformdata.map_coordinates.split(',').map(parseFloat);
          routes.push([start, end]);
        }
        const routejson = val[index].itemformdata.routejson;
        if (this.form.routelinetype === 3 && routejson.curvedata !== undefined && routejson.curvedata.length > 0) {
          routejson.curvedata.forEach((point, pIndex) => {
            if (routes[pIndex] !== undefined) routes[pIndex].splice(1, 0, ...point);
          });
        }
        routesLatLon.push(routes);
      });
      this.routePoint = routeAllPoint;
      this.setRoutePoint(routeAllPoint);
      this.routeHandle(val, routesLatLon);
    },
    // 路线显示操作
    routeHandle(val, routesLatLon) {
      this.routeAllLen = val.length;
      this.routeAllSource = [];
      if (routesLatLon.length === 0) {
        this.routeAllSource = [];
        this.SET_MAPROUTESOURCE([]);
        return;
      }
      if (this.form.routelinetype === 1) {
        // 真实路线
        val.forEach((item, index) => {
          this.routeDriving(routesLatLon[index], 0, [], item.itemformdata.routejson.style, item.id).then(DrivingInfo => {
            if (this.speeds.length > 0) DrivingInfo.speed = this.speeds;
            console.log(`DrivingInfo`, DrivingInfo);
            this.routeAllSource.push(DrivingInfo);
            if (this.routeAllSource.length === this.routeAllLen) this.SET_MAPROUTESOURCE(this.routeAllSource);
          }).catch(error => {
            console.error('出错:', error);
          });
        });
      }
      if (this.form.routelinetype !== 1) {
        val.forEach((item, index) => {
          const paths = routesLatLon[index].map(elem => {
            return elem.map(item => {
              return transform([item[0], item[1]], 'EPSG:4326', 'EPSG:3857');
            });
          });
          const lineInfo = {
            path: paths,
            style: item.itemformdata.routejson.style,
            routelinetype: this.form.routelinetype,
            isCurve: false
          };
          if (this.speeds.length > 0) lineInfo.speed = this.speeds;
          this.routeAllSource.push(lineInfo);
        });
        this.SET_MAPROUTESOURCE(this.routeAllSource);
      }
    },
    // 获取百度真实路线方法
    routeDriving(routes, index, routeItemAllpath, linestyle, id) {
      return new Promise((resolve, reject) => {
        let route = routes[index];
        if (route === undefined) return reject('Route is undefined');
        let start = new window.BMapGL.Point(route[0][0], route[0][1]);
        let end = new window.BMapGL.Point(route[1][0], route[1][1]);
        let driving = new window.BMapGL.DrivingRoute(this.mapcontainer);
        driving.search(start, end);
        driving.setSearchCompleteCallback(() => {
          try {
            let routepath = [];
            if (driving.getResults() === undefined) return reject('No results found');
            let pots = driving.getResults().getPlan(0).getRoute(0).getPath();
            pots.forEach((pot, idx) => {
              let bdTogd = bd_decrypt(pot.lng, pot.lat);
              routepath.push(transform([bdTogd.lng, bdTogd.lat], 'EPSG:4326', 'EPSG:3857'));
            });
            routeItemAllpath.push(routepath);
            if (routes.length === 1 || index === routes.length - 1) {
              const result = {
                path: routeItemAllpath,
                style: linestyle,
                id: id
              };
              resolve(result);
            } else if (routes.length > 1 && index <= routes.length - 1) {
              this.routeDriving(routes, index + 1, routeItemAllpath, linestyle, id).then(resolve).catch(reject);
            }
          } catch (error) {
            reject(error);
          }
        });
      });
    },
    // 显示当前路线上的所有点
    setRoutePoint(val) {
      this.$refs.mapv2assembly.removeAlliconsource();
      this.$refs.mapv2assembly.removeRoutesource();
      this.$refs.mapv2assembly.createPoint(val);
    },
    routeshow(val) {
      this.mapLayers.route = val;
    },
    /**
     * 增加浏览量
     */
    getVisits() {
      let that = this;
      let nowTime = new Date();
      let date = formateDate(nowTime, 'yyyy-MM-dd');
      const searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': 'id',
            'compt': 'editinput',
            'express': '===',
            'val': this.formatData.onlyid
          }, {
            'alias': 'date',
            'compt': 'editinput',
            'express': '===',
            'val': date
          }]
        }]
      };
      this.visitform.deptId = this.query.fid;
      this.visitform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.visitform).then(res => {
        res.totalRow > 0 ? that.editVisit(res, nowTime) : that.addVisit(nowTime, date);
      });
    },
    addVisit(nowTime, date) {
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': ''
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'id',
        'compt': 'editinput',
        'values': [{
          'val': this.formatData.onlyid
        }]
      });
      dataList.push({
        'alias': 'date',
        'compt': 'editinput',
        'values': [{
          'val': date
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': 1
        }]
      });
      console.log(`dataList`, dataList);
      let formData = {
        deptId: this.query.fid,
        formId: this.visitform.formId,
        uid: this.query.uid
      };
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {});
    },
    editVisit(res, nowTime) {
      let resList = this.formdataformat(res);
      let dataList = [];
      dataList.push({
        'alias': 'onlyid',
        'compt': 'autonumber',
        'values': [{
          'val': resList[0].itemformdata.onlyid
        }]
      });
      dataList.push({
        'alias': 'title',
        'compt': 'selectbox',
        'values': [{
          'val': this.formatData.title
        }]
      });
      dataList.push({
        'alias': 'visits',
        'compt': 'numberinput',
        'values': [{
          'val': Number(resList[0].itemformdata.visits) + 1
        }]
      });
      dataList.push({
        'alias': 'timestamp',
        'compt': 'editinput',
        'values': [{
          'val': nowTime.getTime()
        }]
      });
      this.$api.editForm(this.query.fid, resList[0].id, encodeURI(JSON.stringify(dataList)), resList[0].formId).then(res => {});
    },
    /**
     * 添加特效
     */
    // effectAnimate() {
    //     this.$nextTick(() => {
    //         document.querySelector('.yunbox').classList.remove('hidden')
    //         const yunl = document.querySelector('.yunl')
    //         const yunr = document.querySelector('.yunr')
    //         let keyframesl = [{ left: '-100%' }]
    //         let keyframesr = [{ right: '-100%' }]
    //         let options = { duration: 4000, iterations: 1, fill: 'forwards' }
    //         yunl.animate(keyframesl, options).onfinish = () => {
    //             const yunbox = document.querySelector('.yunbox')
    //             if (yunbox !== null) yunbox.classList.add('hidden')
    //         }
    //         yunr.animate(keyframesr, options).onfinish = () => { }
    //     })
    // },

    effectAnimate() {
      this.$nextTick(() => {
        const yunbox = document.querySelector('.yunbox');
        const yunl = document.querySelector('.yunl');
        const yunr = document.querySelector('.yunr');
        if (!yunbox || !yunl || !yunr) return;
        yunbox.classList.remove('hidden');
        let keyframesl = [{
          left: getComputedStyle(yunl).left
        }, {
          left: '-100%'
        }];
        let keyframesr = [{
          right: getComputedStyle(yunr).right
        }, {
          right: '-100%'
        }];
        let options = {
          duration: 4000,
          iterations: 1,
          fill: 'forwards'
        };
        yunl.animate(keyframesl, options).onfinish = () => {
          yunbox.classList.add('hidden');
        };
        yunr.animate(keyframesr, options).onfinish = () => {};
      });
    },
    /**
     * 背景音乐操作事件
     */
    bgaudioHandle() {
      this.bgaudioflag = !this.bgaudioflag;
      if (this.form.bgaudioicon) {
        this.mapelem.bgaudio = !this.bgaudioflag ? this.form.bgaudioicon[1] ? getImg(this.form.bgaudioicon[1]) : '' : this.form.bgaudioicon[0] ? getImg(this.form.bgaudioicon[0]) : '';
      }
      if (this.form.bgaudiofile && this.form.bgaudiofile[0]) {
        !this.bgaudioflag ? this.$refs.bgaudio.pause() : this.$refs.bgaudio.play();
      }
    },
    /**
     * 获取背景音乐文件
     */
    getBgaudiofile(val) {
      this.$api.getUrlByObjectId(val.objectid || val.objectId).then(res => {
        this.bgaudio = res.http;
      });
    },
    domChange(item) {
      /* 展示页不需要编辑dom样式 */
      if (this.id === 1) {
        console.log(item);
        if (!item.data || Object.keys(item.data).length === 0) return;
        if (item.data.url !== '') {
          const openUrl = openComponentUrl(item.data.url);
          item.data.way ? window.open(openUrl) : window.location.href = openUrl;
        }
        return;
      }
      console.log(item);
      this.$emit('domclick', item);
    },
    getComponentImageSrc(item) {
      const url = item && item.image && item.image[0] && item.image[0].fileUrl ? item.image[0].fileUrl : '';
      if (!url) return 'https://p.cldisk.com/star3/origin/bcf319ee85abda331c2cae8b0ac6e71b.jpg';
      return String(url).replace(/^http:\/\/p\.cldisk\.com/i, 'https://p.cldisk.com');
    },
    getdomStyle(val) {
      const data = {
        ...(val || {})
      };
      const defaultdata = {
        ...data
      };
      const scaleX = data.scaleX ? data.scaleX : 1;
      const scaleY = data.scaleY ? data.scaleY : 1;
      const boxWidth = Math.round((defaultdata.width || 0) * scaleX);
      const boxHeight = Math.round((defaultdata.height || 0) * scaleY);
      const css = {};
      if (!this.isMobileflag) {
        const bodywidth = this.form.pcwidth;
        const bodyheight = this.form.pcheight;
        if (data.x <= bodywidth / 2) {
          css.left = Math.round(data.x) + 'px';
        } else {
          css.right = Math.abs(bodywidth - Math.round(data.x) - boxWidth) + 'px';
        }
        if (data.y <= bodyheight / 2) {
          css.top = Math.round(data.y) + 'px';
        } else {
          css.bottom = Math.abs(bodyheight - Math.round(data.y) - boxHeight) + 'px';
        }
        css.width = boxWidth + 'px';
        css.height = boxHeight + 'px';
      } else {
        const bodywidth = 375;
        const bodyheight = 667;
        if (this.id === 1) {
          const innerWidth = window.innerWidth;
          const innerHeight = window.innerHeight;
          const scale = Math.min(innerWidth / bodywidth, innerHeight / bodyheight);
          css.width = `${scale * boxWidth}px`;
          css.height = `${scale * boxHeight}px`;
          css.left = `${scale * data.x}px`;
          css.top = `${scale * data.y}px`;
        } else {
          css.width = `${boxWidth}px`;
          css.height = `${boxHeight}px`;
          css.left = `${Math.round(data.x)}px`;
          css.top = `${Math.round(data.y)}px`;
        }
      }
      return css;
    },
    /**
     * 单个点位样式改变事件
     * @param {Object} val 数据
     * @date 2025-06-04
     */
    setPointStyle(val) {
      this.$refs.mapv2assembly.setsinglePointStyle(val);
    },
    changeMapShadowList(data) {
      this.$refs.mapv2assembly.changeMapShadowList(data);
    },
    setDecorationpoint(data) {
      this.$refs.mapv2assembly.addDecorationpoint(data);
    },
    resetMap() {
      this.$refs.mapv2assembly.resetMap();
    },
    /**
     * 获取超图机器人sdk
     */
    getCxRobotSdkJs() {
      let me = this;
      if (this.$route.query.fid === '291435') {
        const options = {
          appId: 103774579,
          appAuthToken: "2809bf057ffa3feec59b95dbd84732ce",
          unitId: 291435,
          robotId: "6033ce7e4ace4ef0a064fe941ecdb07b",
          groupId: 0,
          origin: 'https://robot.chaoxing.com',
          accessToken: "aed4ab6c1b626801def6364c2da02d47",
          scene: ""
        };
        CxRobotSdkJs.init(options).then(robot => {
          me.robot = robot;
          // 监听机器人消息
          robot.on("message", message => {
            console.log("message", message);
            if (message !== undefined && message.messageType === 'TEXT' && message.cmdAnswer) {
              try {
                const cmdObj = JSON.parse(message.cmdAnswer);
                const cmd = cmdObj.cmd || '';
                const match = cmd.match(/\$([^$]+)\$/);
                if (match) {
                  const keyword = match[1];
                  console.log('提取到关键词:', keyword); // 调试信息
                  this.robotSearchkeyword = keyword;

                  // 根据关键词查询分类数据
                  const typeStr = me.robotgetType(keyword);
                  if (typeStr && typeStr.index) {
                    me.isRobot = true;
                    me.typeClick(typeStr);
                    me.activetype = typeStr;
                  } else {
                    // 根据关键词查询点位数据
                    const resetform = _.cloneDeep(this.pointform);
                    const resetsearchStr = {
                      model: 0,
                      filters: [{
                        "model": 0,
                        "filters": [{
                          'alias': 'place_name',
                          'compt': 'editinput',
                          'express': '===',
                          'val': keyword
                        }]
                      }]
                    };
                    resetform.searchStr = encodeURI(JSON.stringify(resetsearchStr));
                    me.$api.singleadvanceSearch(resetform).then(res => {
                      // 存在点位数据
                      if (res.totalRow > 0) {
                        me.isRobot = true;
                        let dataList = me.formdataformat(res, 'point');
                        const pointZoom = Number(dataList[0].itemformdata.map_level);
                        // 点位数据存在分类数据 设置分类选中样式
                        if (dataList[0].itemformdata.map_type2 !== '') {
                          const map_type = dataList[0].itemformdata.map_type2;
                          const searchType = map_type.includes(',') ? map_type.split(',')[0] : map_type;
                          const pointTypeStr = me.robotgetType(searchType);
                          if (pointTypeStr && pointTypeStr.index) {
                            me.activetype = pointTypeStr;
                            me.typeClick(pointTypeStr, pointZoom);
                          }
                        } else {
                          // 设置地图缩放级别
                          me.mapview.zoom = pointZoom;
                        }
                      } else {
                        ElMessage({
                          message: '查询的关键词地图不存在数据',
                          type: 'warning'
                        });
                      }
                    });
                  }
                }
              } catch (e) {
                console.error('解析cmdAnswer失败:', e);
              }
            }
          });
        });
      }
    },
    robotgetType(keyword) {
      const searchtypeList = _.cloneDeep(this.typeList);
      let typeItem = {};
      searchtypeList.forEach((item, index) => {
        if (item.itemformdata.title === keyword) {
          typeItem = {
            index: index,
            item: item
          };
        } else {
          let nextLevel = [];
          if (item?.itemformdata?.json != null && item.itemformdata.json !== '') {
            nextLevel.push(...JSON.parse(item.itemformdata.json.replace(/(<\/?p.*?>)/gi, "")));
          }
          nextLevel.forEach(child => {
            if (child.itemformdata.title === keyword) {
              typeItem = {
                index: index,
                item: item,
                child: child,
                cIndex: cIndex
              };
            }
          });
        }
      });
      return typeItem;
    }
  }
};